import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, imgSrc } from "../../lib/api";

export const GalleryPreview = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/gallery").then((r) => setItems(r.data.slice(0, 4))).catch(() => {}); }, []);
  return (
    <div className="mt-10" data-testid="gallery-preview">
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        {items.map((it) => (
          <div key={it.id} className="group overflow-hidden rounded-2xl">
            <img src={imgSrc(it)} alt={it.caption} className="aspect-square w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
          </div>
        ))}
      </div>
      <Link to="/gallery" className="mt-8 inline-flex items-center gap-2 font-semibold text-[#FF1F8E] hover:underline" data-testid="gallery-preview-link">View the full gallery <ArrowRight className="h-4 w-4" /></Link>
    </div>
  );
};
